export { default } from "./productCard";
export { default as GenericProductCard } from "./genericProductCard";
